interface TokenState {
  accessToken: string | null;
  expiresAt: number;
}

const tokenState: TokenState = {
  accessToken: null,
  expiresAt: 0,
};

// If a refresh is already in progress, everyone waits for it.
let refreshPromise: Promise<string> | null = null;

export function setToken(
  token: string,
  expiresIn?: number
) {
  tokenState.accessToken = token;

  if (expiresIn !== undefined) {
    tokenState.expiresAt =
      Date.now() + expiresIn * 1000;
  }
}

export function clearToken() {
  tokenState.accessToken = null;
  tokenState.expiresAt = 0;
}

export async function getValidToken(): Promise<string> {
  if (
    tokenState.accessToken &&
    Date.now() < tokenState.expiresAt - 30_000
  ) {
    return tokenState.accessToken;
  }

  return refreshToken();
}

export async function refreshToken(): Promise<string> {
  //
  // Someone else is already refreshing.
  //
  if (refreshPromise) {
    return refreshPromise;
  }

  refreshPromise = (async () => {
    const response = await fetch(
      `${process.env.NEXT_PUBLIC_API_URL}/auth/refresh`,
      {
        method: "POST",
        credentials: "include",
      }
    );

    if (!response.ok) {
      clearToken();
      throw new Error("Unable to refresh session");
    }

    const data = await response.json();

    setToken(data.token, data.expiresIn);

    return tokenState.accessToken!;
  })();

  try {
    return await refreshPromise;
  } finally {
    refreshPromise = null;
  }
}

export async function logout() {
  clearToken();

  await fetch(
    `${process.env.NEXT_PUBLIC_API_URL}/auth/logout`,
    {
        method: "DELETE",
        // credentials: "include",
    }
  );
}